import CreateScheduleEmail from '../../../../../components/ScheduleEmail/CreateScheduleEmail/CreateScheduleEmail'

const CreateScheduleEmailScreen = () => {
    return (
        <CreateScheduleEmail/>
    )
}

export default CreateScheduleEmailScreen